import { formatCurrency } from '../../utils/datetime';
import { METHOD_LABELS, useWorkspaceSales } from '../../hooks/useWorkspaceSales';
import PayoutStatusCard from '../sales/PayoutStatusCard';

const ReportsReconciliation = () => {
  const { data, loading, error } = useWorkspaceSales();
  const currency = data?.currency || 'GHS';
  const rows = data?.reports?.byMethod || [];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl font-light text-ink-900">Payment reconciliation</h2>
        <p className="mt-1 text-sm text-ink-700/80">
          What clients paid online vs what has been sent to your connected account.
        </p>
      </div>

      {error && (
        <div className="border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800">{error}</div>
      )}

      <PayoutStatusCard payout={data?.payout} currency={currency} loading={loading} />

      {loading ? (
        <div className="flex justify-center py-16">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-ink-900/20 border-t-saffron-500" />
        </div>
      ) : rows.length === 0 ? (
        <p className="bg-sand-50 px-5 py-16 text-center text-sm text-ink-700/70 ring-1 ring-ink-900/10">
          No online payments to reconcile yet.
        </p>
      ) : (
        <ul className="divide-y divide-ink-900/10 bg-sand-50 ring-1 ring-ink-900/10">
          {rows.map((row) => (
            <li
              key={row.method}
              className="flex flex-col gap-2 px-5 py-4 sm:flex-row sm:items-center sm:justify-between"
            >
              <div>
                <div className="flex flex-wrap items-center gap-2">
                  <p className="font-medium text-ink-900">
                    {METHOD_LABELS[row.method] || row.method}
                  </p>
                  <span
                    className={`px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] ${
                      row.status === 'matched'
                        ? 'bg-emerald-50 text-emerald-800'
                        : 'bg-saffron-500/15 text-saffron-800'
                    }`}
                  >
                    {row.status}
                  </span>
                </div>
                <p className="mt-1 text-sm text-ink-700/75">
                  Collected {formatCurrency(row.collected, currency)}
                  {row.pending > 0
                    ? ` · ${formatCurrency(row.pending, currency)} awaiting payout`
                    : ''}
                </p>
              </div>
              <div className="text-right">
                <p className="font-display text-2xl font-light text-ink-900">
                  {formatCurrency(row.paidOut, currency)}
                </p>
                <p className="mt-0.5 text-xs text-ink-600/60">sent / settled</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ReportsReconciliation;
